module.exports = __webpack_public_path__ + "assets/img/home3-box3-img2.f665ce3a.png";